<template>
    <v-row justify="center">
        <v-dialog :retain-focus="false" v-model="dialog" @update:return-value="emited"
                  transition="dialog-bottom-transition">
            <v-card>
                <v-toolbar dense dark color="primary">
                    <v-btn icon dark @click="dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Article composer (#{{ article.id }})</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn :disabled="!isLoaded" :href="previewUrl" target="_blank" dark text @click="log">Preview
                        </v-btn>
                        <v-btn v-if="can('magazine-article-edit')" dark text @click="save">Save</v-btn>
                    </v-toolbar-items>
                </v-toolbar>

                <v-container>

                    <v-tabs icons-and-text grow v-model="active_tab">
                        <v-tab>
                            <v-icon>mdi-format-text</v-icon>
                            Header
                        </v-tab>
                        <v-tab>
                            <v-icon>mdi-content-copy</v-icon>
                            Content
                        </v-tab>
                        <v-tab>
                            <v-icon>mdi-content-duplicate</v-icon>
                            Marketing
                        </v-tab>
                        <v-tab>
                            <v-icon>mdi-plus-circle-outline</v-icon>
                            Optional
                        </v-tab>

                        <v-tab-item>
                            <v-card flat>
                                <v-card-text>
                                    <v-text-field
                                        v-model="article.title"
                                        :counter="100"
                                        :rules="titleRules"
                                        filled
                                        label="Title of article"
                                    ></v-text-field>

                                    <v-textarea
                                        v-model="article.perex"
                                        :rules="perexRules"
                                        :counter="250"
                                        filled
                                        label="Perex"
                                        auto-grow
                                        value=""
                                    ></v-textarea>

                                    <v-row>
                                        <v-col cols="12" md="6">
                                            <v-text-field
                                                v-model="article.author"
                                                label="Personality name"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-text-field
                                                v-model="article.editor"
                                                label="Editor name"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col cols="12" lg="2">
                                            <v-switch
                                                v-model="article.is_published"
                                                :label="`Published on/off`"
                                            ></v-switch>
                                        </v-col>
                                        <v-col cols="12" lg="5">

                                            <v-menu
                                                v-model="published_from"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                transition="scale-transition"
                                                offset-y
                                                min-width="290px"
                                            >
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field
                                                        v-model="article.published_from"
                                                        label="Article published from (optional)"
                                                        prepend-icon="mdi-calendar-check"
                                                        readonly
                                                        v-on="on"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker v-model="article.published_from"
                                                               @input="published_from = false"></v-date-picker>
                                            </v-menu>
                                        </v-col>

                                        <v-col cols="12" lg="5">
                                            <v-menu
                                                v-model="published_to"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                transition="scale-transition"
                                                offset-y
                                                min-width="290px"
                                            >
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field
                                                        v-model="article.published_to"
                                                        label="Article published to (optional)"
                                                        prepend-icon="mdi-calendar-remove"
                                                        readonly
                                                        v-on="on"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker v-model="article.published_to"
                                                               @input="published_to = false"></v-date-picker>
                                            </v-menu>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col>

                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="6" lg="6" sm="12">
                                            <v-alert type="warning" v-if="!isLoaded">
                                                Unable to upload title image till you save article first time.
                                            </v-alert>
                                            <v-card :disabled="!isLoaded">
                                                <v-card-title>
                                                    Title image
                                                </v-card-title>
                                                <v-card-subtitle>
                                                    path: {{ article.image }}
                                                </v-card-subtitle>
                                                <v-img
                                                    :src="article.image_path"
                                                    height="250"
                                                    contain
                                                ></v-img>
                                                <v-card-title class="title">
                                                    <v-file-input
                                                        v-model="file"
                                                        label="Select Image File..."
                                                        accept="image/*"
                                                        @change="loadImage"
                                                    ></v-file-input>
                                                </v-card-title>
                                            </v-card>
                                        </v-col>
                                        <v-col cols="6" lg="6" sm="12">
                                            <v-card>
                                                <v-card-title>
                                                    Categories
                                                </v-card-title>
                                                <v-card-text>
                                                    <v-switch
                                                        v-for="cat in article.available_categories"
                                                        :key="cat.id"
                                                        v-model="article.category_ids"
                                                        :label="cat.title"
                                                        :value="cat.id"
                                                    ></v-switch>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                        <v-tab-item>
                            <v-card flat>
                                <v-card-text>
                                    <editor
                                        style="z-index: 99999"
                                        :disabled=false
                                        api-key="no-api-key"
                                        v-model="article.content"
                                        initial-value=""
                                        :init="{
                                            images_upload_url: 'api/image/article/'+article.id,
                                            height: 900,
                                            menubar: false,
                                            branding: false,
                                            plugins: [
                                                'advlist autolink lists link image charmap print preview anchor',
                                                'searchreplace visualblocks code fullscreen',
                                                'insertdatetime media table paste code help wordcount'
                                            ],
                                            style_formats: [
                                                { title: 'Paragraph', block: 'p' },
                                                { title: 'Question', block: 'blockquote', classes: 'question' },
                                                { title: 'Image description', block: 'p', classes: 'description' },
                                                { title: 'Header 2', block: 'h2' },
                                                { title: 'Header 3', block: 'h3' }
                                            ],
                                            toolbar: 'fullscreen undo redo | styleselect | link unlink | media image | bold italic underline | alignleft aligncenter alignright alignjustify | bullist numlist | removeformat | code help'
                                        }"
                                    />
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                        <v-tab-item>
                            <carousel
                                :perex="false"
                                :article="article"
                            ></carousel>
                        </v-tab-item>
                        <v-tab-item>
                            comming soon...
                        </v-tab-item>
                    </v-tabs>

                </v-container>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>

import Editor from '@tinymce/tinymce-vue'
import api from '../../_api'
import carousel from '../carousel/items'

export default {
    name: "article_detail",

    components: {
        'editor': Editor,
        'carousel': carousel
    },

    props: {
        article: {},
        open: false,
    },

    data: () => ({
        active_tab: 1,
        file: null,
        content: '',
        dialog: false,
        notifications: false,
        sound: true,
        widgets: false,
        titleRules: [
            v => !!v || 'Title is required',
            v => (v && v.length <= 100) || 'Title must be less than 100 characters',
        ],
        perexRules: [
            v => !!v || 'Perex is required',
            v => (v && v.length <= 250) || 'Perex must be less than 250 characters',
        ],
        published_from: false,
        published_to: false,
        is_published: false
    }),

    watch: {
        open: function () {
            this.active_tab = 0
            this.dialog = this.open
        }
    },

    computed: {
        isLoaded() {
            return (this.article.id === 0) ? false : true
        },

        previewUrl() {
            return process.env.MIX_URL_MAGAZINE + this.article.slug + '/preview';
        }
    },

    created() {

    },

    methods: {
        emited() {
            this.article.content = "";
            this.article.image = "";
            this.file = null;
            this.$emit('closeArticle');
        },

        log() {
            console.log(this.article.content)
        },

        save() {

            // update article
            if (this.article.id == 0)
                this.create()
            else {

                api.updateArticle(this.article, this.file).then((response) => {

                    if (response.status == 200)
                        this.$emit('articleUpdated')

                    return (response.status)

                }).then((responseStatus) => {
                    if (responseStatus == 200)
                        this.dialog = false
                    else
                        alert('Error ' + responseStatus)
                })

            }
        },

        // create new article
        create() {
            api.createArticle(this.article).then((response) => {

                if (response.status == 200)
                    this.$emit('articleUpdated')

                return (response.status)

            }).then((responseStatus) => {
                if (responseStatus == 200)
                    this.dialog = false;
                else
                    alert('Error ' + responseStatus)
            })
        },

        loadImage() {

            api.uploadTitleImage(this.article.id, this.file).then((response) => {
                if (response.status == 200)
                    alert('image uploaded')
                else
                    alert('error: '.response.status)

                this.article.image_path = response.data.location;
                this.article.image = response.data.name;

                return (response.status)
            })
        }
    }
}
</script>

<style>

.v-dialog > .v-card > .v-toolbar {
    position: sticky;
    top: 0;
    z-index: 999;
}

</style>
